// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import zh_hans from './locales/zh_hans.json'

const resources = {
    zh: {
        translation: zh_hans
    }
}
i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: "zh",
        fallbackLng: "zh",
        debug: true,
        detection: {
            order: ["queryString", "cookie"],
            cache: ["cookie"]
        },
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;